import React, { useState } from "react";
import { HiArrowSmUp, HiArrowSmDown } from "react-icons/hi";
import LoginDialog from "components/card/LoginDialog";
import VerifyEmailDialog from "components/card/VerifyEmailDialog";

const VoteButtonsMini = ({ state = "", onChange, currentUser, isDisabled }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [isOpenVerifyEmailDialog, setIsOpenVerifyEmailDialog] = useState(false);

  const handleDisagreeClick = () => {
    if (!currentUser) {
      setIsOpen(true);
      return;
    }
    if (currentUser && !currentUser.emailVerified) {
      if (currentUser.providerData?.[0].providerId !== "facebook.com") {
        setIsOpenVerifyEmailDialog(true);
        return;
      }
    }
    if (!isDisabled) onChange("disagree");
  };

  const handleAgreeClick = () => {
    if (!currentUser) {
      setIsOpen(true);
      return;
    }
    if (currentUser && !currentUser.emailVerified) {
      if (currentUser.providerData?.[0].providerId !== "facebook.com") {
        setIsOpenVerifyEmailDialog(true);
        return;
      }
    }
    if (!isDisabled) onChange("agree");
  };

  return (
    <div className="flex justify-end items-center shrink-0">
      <div className="flex items-center bg-slate-100 dark:bg-slate-800/80 p-1 px-2.5 rounded-full border border-slate-200/80 dark:border-slate-700/60 shadow-sm gap-1.5 text-slate-700 dark:text-slate-300">
        <button
          title={isDisabled ? "Քվեարկությունը ավարտված է" : "Համաձայն չեմ"}
          onClick={handleDisagreeClick}
          disabled={isDisabled}
          className={`flex items-center justify-center p-1 rounded-full hover:text-red-500 transition-colors ${
            state === "disagree" ? "text-red-500 font-bold bg-red-50 dark:bg-red-950/40" : "text-slate-600 dark:text-slate-400"
          }`}
        >
          <HiArrowSmDown size={18} />
        </button>

        <span className="text-slate-300 dark:text-slate-600 text-xs font-light select-none">|</span>

        <button
          title={isDisabled ? "Քվեարկությունը ավարտված է" : "Համաձայն եմ"}
          onClick={handleAgreeClick}
          disabled={isDisabled}
          className={`flex items-center justify-center p-1 rounded-full hover:text-[#0033FF] transition-colors ${
            state === "agree" ? "text-[#0033FF] font-bold bg-blue-50 dark:bg-blue-950/40" : "text-slate-600 dark:text-slate-400"
          }`}
        >
          <HiArrowSmUp size={18} />
        </button>
      </div>

      <LoginDialog isOpen={isOpen} handleClose={() => setIsOpen(false)} />
      <VerifyEmailDialog
        isOpen={isOpenVerifyEmailDialog}
        handleClose={() => setIsOpenVerifyEmailDialog(false)}
      />
    </div>
  );
};

export default VoteButtonsMini;

